import dayjs from 'dayjs';
import { getInspectionDeviceReadiness, getMyInspectionDeviceReadiness } from '../../modules/inspection-appointments/services/inspection-appointmentService';
import type { InspectionDeviceReadiness } from '../../modules/inspection-appointments/services/inspection-appointmentService';

export type DeviceReadinessPeriod = 7 | 30;
export type DeviceReadinessScope = 'all' | 'me';

export const loadDeviceReadiness = (
  scope: DeviceReadinessScope,
  startDate: string,
  endDate: string,
): Promise<InspectionDeviceReadiness[]> => scope === 'me'
  ? getMyInspectionDeviceReadiness(startDate, endDate)
  : getInspectionDeviceReadiness(startDate, endDate);

export const getMissingPlansInRange = (
  plans: InspectionDeviceReadiness[],
  startDate: string,
  days: DeviceReadinessPeriod,
): InspectionDeviceReadiness[] => {
  const start = dayjs(startDate).startOf('day');
  const endExclusive = start.add(days, 'day');
  return plans.filter((plan) => plan.status === 'MISSING' && plan.inspectorId != null
    && dayjs(plan.startDate).isBefore(endExclusive) && dayjs(plan.endDate).isAfter(start));
};
